module.exports = __webpack_public_path__ + "assets/img/credit-score.04832710.png";